// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper ensures the slider fills 100% width */
.carousel-banner-wrapper {
  width: 100%;
  overflow: hidden;
  background: #0f172a;          /* dark bg fills letterbox areas cleanly */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 1rem 1rem;
}

/*
  react-simple-image-slider renders <img> with inline style objectFit:'fill'.
  Override to 'contain' so the WHOLE image is always visible, centred,
  with no cropping. Dark bg fills any remaining space.
*/
.carousel-banner-wrapper img {
  object-fit: contain !important;
  object-position: center center !important;
  display: block;
  width: 100% !important;
  height: 100% !important;
}

/* Nav arrow buttons – responsive size via CSS as a second layer of control */
.carousel-banner-wrapper button {
  outline: none;
  /* scale the SVG arrow icon inside the button */
  font-size: clamp(10px, 3vw, 18px) !important;
}

/* Shrink arrow buttons further on very small screens */
@media (max-width: 480px) {
  .carousel-banner-wrapper button {
    min-width: 24px !important;
    min-height: 24px !important;
    width: 24px !important;
    height: 24px !important;
  }
  /* Scale down the SVG path drawn inside the nav button */
  .carousel-banner-wrapper button svg {
    width: 12px !important;
    height: 12px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/CarouselBanner.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB,WAAW,0CAA0C;EACxE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;;;CAIC;AACD;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA,uDAAuD;AACvD;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;EACzB;EACA,wDAAwD;EACxD;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* Wrapper ensures the slider fills 100% width */\n.carousel-banner-wrapper {\n  width: 100%;\n  overflow: hidden;\n  background: #0f172a;          /* dark bg fills letterbox areas cleanly */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0 0 1rem 1rem;\n}\n\n/*\n  react-simple-image-slider renders <img> with inline style objectFit:'fill'.\n  Override to 'contain' so the WHOLE image is always visible, centred,\n  with no cropping. Dark bg fills any remaining space.\n*/\n.carousel-banner-wrapper img {\n  object-fit: contain !important;\n  object-position: center center !important;\n  display: block;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Nav arrow buttons – responsive size via CSS as a second layer of control */\n.carousel-banner-wrapper button {\n  outline: none;\n  /* scale the SVG arrow icon inside the button */\n  font-size: clamp(10px, 3vw, 18px) !important;\n}\n\n/* Shrink arrow buttons further on very small screens */\n@media (max-width: 480px) {\n  .carousel-banner-wrapper button {\n    min-width: 24px !important;\n    min-height: 24px !important;\n    width: 24px !important;\n    height: 24px !important;\n  }\n  /* Scale down the SVG path drawn inside the nav button */\n  .carousel-banner-wrapper button svg {\n    width: 12px !important;\n    height: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
